// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { AuthProvider } from './auth-context'; // Ensure the path is correct
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
